import styled, { keyframes } from "styled-components";
import HeroSection from "../../assets/icons/HeroSection2.png";
// import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

const slideIn = keyframes`
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
`;

export const HeroSectionContainer = styled.div`
  background-image: url("/assets/icons/HeroSection2.png");
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding-top: 40px;
`;
export const HeroBoxing = styled.div`
  padding: 0 20%;
  margin: 4rem;
  animation: ${slideIn} 1s ease-in-out;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    padding: 0px;
  }
  @media screen and (min-width: 767px) and (max-width: 1024px) {
    width: 100%;
    padding: 0px;
    margin: 20px;
  }
`;

export const HeroSectionDiv1 = styled.button`
  background-color: #00c7031a;
  border-radius: 30px;
  padding: 0 3.5rem;
  margin-top: 10px;
  border: 0px;
  outline: none;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin: 10px;
  }
`;
export const HeroSectionDiv1P = styled.p`
  font-family: GT Walsheim Pro;

  font-size: ${fipayFonts.fipayFonts.fontSize.body3};

  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};

  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: center;
  color: #00c703;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.footer1};

    line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
  }
`;
export const HeroSectionDiv2 = styled.div`
  color: #09005b;
  font-family: GT Walsheim Pro;

  font-size: ${fipayFonts.fipayFonts.fontSize.display2};

  font-size: ${fipayFonts.fipayFonts.fontWeight.bold};

  line-height: ${fipayFonts.fipayFonts.lineHeight.display2};

  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  text-align: center;
  margin-top: -30px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.heading3};

    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
  }
`;

export const HeroSectionDiv3 = styled.div`
  color: #5e5e5e;
  font-family: GT Walsheim Pro;

  font-size: ${fipayFonts.fipayFonts.fontSize.body1};

  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};

  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};

  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: center;
  margin-top: -20px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body2};

    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    margin-top: 10px;
  }
`;

export const HeroSectionDiv3P = styled.p`
  font-family: GT Walsheim Pro;
  color: #5e5e5e;

  font-size: ${fipayFonts.fipayFonts.fontSize.body1};

  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};

  line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};

  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: center;
  margin-top: -20px;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body2};

    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    width: 327px;
  }
`;

export const HeroSectionCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 50px 10px;
  margin: 30px;

  & > * {
    flex-basis: calc(25% - 55px);
  }

  @media screen and (max-width: 1024px) {
    & > * {
      flex-basis: calc(50% - 55px);
    }
  }

  @media screen and (max-width: 766px) {
    & > * {
      flex-basis: calc(100% - 25px); /* 1 card per row */
    }
    justify-content: space-evenly;
    margin-top: 5px;
    gap: 1rem;
  }
  @media screen and (min-width: 1024px) and (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @keyframes slideInFromBottom {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const HeroSectionCards = styled.div`
  background-color: white;
  box-shadow: 0px 4px 50px 0px #d4d0c54a;
  padding: 20px;
  width: 250px;
  height: auto;
  border-radius: 10px;
  transition: transform 0.2s ease-in-out;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    transition: transform 0.2s ease-in-out;
    height: auto;
    padding: 40px;
  }
  &:hover {
    transform: translateY(-20px);
    box-shadow: 0px 12px 16px rgba(0.1, 0.1, 0.1, 0.2);

    @media screen and (min-width: 0px) and (max-width: 766px) {
      transform: translateY(-40px);
      box-shadow: 0px 12px 16px rgba(0.1, 0.1, 0.1, 0.2);
    }
  }
`;

export const HeroSectionImage = styled.img`
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 30px;
    height: 30px;
  }
`;

export const HeroSectionTitle = styled.h4`
  color: #09005b;
  margin-top: 15px;
  font-family: GT Walsheim Pro;

  font-size: ${fipayFonts.fipayFonts.fontSize.temp1};

  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};

  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};

  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-family: GT Walsheim Pro;

    font-size: ${fipayFonts.fipayFonts.fontSize.body1};

    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};

    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};

    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    text-align: center;
  }
`;

export const HeroSectionContent = styled.p`
  color: #5e5e5e;
  margin-top: -15px;
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  font-family: GT Walsheim Pro;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    text-align: center;
  }
`;
